module.exports = __webpack_public_path__ + "media/bootstrap-icons/mic-98107c9d.svg";